export default __webpack_public_path__ + "static/program_1-59f97866f87d76afcde73182a675218e.png";